import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCancellationRequest } from '../../service';

type UseCancellationRequestOpts = {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

function useCancellationRequestMutation(
    propertyId: string | number,
    opts: UseCancellationRequestOpts = {}
) {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: (data: {
            services: number[];
            cancellationReasonId: number;
            notes: string | null;
        }) => createCancellationRequest(
            propertyId,
            data.services,
            data.cancellationReasonId,
            data.notes
        ),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['property', propertyId],
            });

            void queryClient.removeQueries({
                queryKey: ['property', propertyId, 'cancellation-request-summary'],
            });

            if (opts.onSuccess !== undefined) {
                opts.onSuccess();
            }
        },
        onError: (error) => {
            if (opts.onError !== undefined) {
                opts.onError(error);
            }
        },
    });

    return query;
}

export { useCancellationRequestMutation };
